var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataGrid',{attrs:{"fields":_vm.fields,"data":_vm.tableData,"data-retriever":_vm.getData()}})}
var staticRenderFns = []

export { render, staticRenderFns }